// DEV-2684 — modül gösterim ağacı kurucuları (kişiye özel yetki modalı). KullaniciIzinleriMatris.vue'daki
// `gosterimAgaci` / `duzDugumler` ile AYNI davranış: kanonik MODUL_AGACI yalnız verilen (sunucunun
// döndürdüğü) modüllere özyinelemeli süzülür; ağaçta olmayan modül kendi ürün grubuna ya da sonda
// "Diğer" grubuna eklenir. Görünen ad API etiketinden (`etiketHaritasi`) gelir.
import {MODUL_AGACI, ModulDugumu, UrunGrubu, modulEtiketi, tumModulAnahtarlari} from "@/enum/YetkiModulleri";

export interface DuzDugum {
  dugum: ModulDugumu;
  seviye: number;
  ustZinciri: string[];
}

export function gosterimAgaciKur(
  sunucuModulleri: string[],
  urunHaritasi: { [modul: string]: string | null | undefined } = {},
  etiketHaritasi: { [modul: string]: string | null | undefined } = {}
): UrunGrubu[] {
  const sunucuda = new Set(sunucuModulleri);

  const suz = (dugumler: ModulDugumu[]): ModulDugumu[] => {
    const sonuc: ModulDugumu[] = [];
    dugumler.forEach((dugum) => {
      if (!sunucuda.has(dugum.modul)) {
        return;
      }
      const cocuklar = suz(dugum.cocuklar || []);
      sonuc.push({modul: dugum.modul, label: modulEtiketi(dugum.modul, etiketHaritasi[dugum.modul]), cocuklar: cocuklar.length ? cocuklar : undefined});
    });
    return sonuc;
  };

  const gruplar: UrunGrubu[] = [];
  MODUL_AGACI.forEach((grup) => {
    const dugumler = suz(grup.dugumler);
    if (dugumler.length) {
      gruplar.push({urun: grup.urun, baslik: grup.baslik, dugumler});
    }
  });

  const agactakiler = new Set(tumModulAnahtarlari());
  sunucuModulleri.forEach((modul) => {
    if (agactakiler.has(modul)) {
      return;
    }
    const urun = urunHaritasi[modul] || null;
    let grup = gruplar.find((g) => g.urun === urun);
    if (!grup) {
      grup = gruplar.find((g) => g.urun === "diger");
      if (!grup) {
        grup = {urun: "diger", baslik: "Diğer", dugumler: []};
        gruplar.push(grup);
      }
    }
    grup.dugumler.push({modul, label: etiketHaritasi[modul] || modul});
  });

  return gruplar;
}

/** Düğümleri özyinelemeli düz listeye açar (girinti seviyesi + ata zinciri ile). */
export function duzDugumler(dugumler: ModulDugumu[], seviye = 0, ustZinciri: string[] = []): DuzDugum[] {
  const liste: DuzDugum[] = [];
  dugumler.forEach((dugum) => {
    liste.push({dugum, seviye, ustZinciri});
    if (dugum.cocuklar && dugum.cocuklar.length) {
      liste.push(...duzDugumler(dugum.cocuklar, seviye + 1, [...ustZinciri, dugum.modul]));
    }
  });
  return liste;
}
